// extracted by mini-css-extract-plugin
module.exports = {"root":"UploadDialog_root__oC5zj","titleWrap":"UploadDialog_titleWrap__1DrIi","viewUpload":"UploadDialog_viewUpload__3g3cY","uploadButton":"UploadDialog_uploadButton__1hdVv"};